"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.selectButtonPropType = exports.imagePropType = exports.descriptionPropType = exports["default"] = exports.columnsPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var descriptionPropType = _propTypes["default"].shape({
  mainHeading: _propTypes["default"].string,
  paragraph: _propTypes["default"].string
});
exports.descriptionPropType = descriptionPropType;
var selectButtonPropType = _propTypes["default"].string;
exports.selectButtonPropType = selectButtonPropType;
var columnsPropType = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  image: imagePropType,
  description: descriptionPropType,
  selectButton: selectButtonPropType
}));
exports.columnsPropType = columnsPropType;
var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  columns: columnsPropType,
  handleFieldChange: _propTypes["default"].func
});
var _default = PROP_TYPES;
exports["default"] = _default;